export default {"src":"/_next/static/media/hyperlink-dark.e53a6c63.svg","height":16,"width":16};